/* client/src/components/ProfilePosts/CreatePostModal.js */
import React, { useState } from 'react';
import { authFetch } from '../../Utilities/Api';
// ✅ FIXED: Removed unused icons (FaGlobeAmericas, FaUserFriends, FaLock)
import { FaTimes, FaImage } from 'react-icons/fa';
import './CreatePostModal.css';

const CreatePostModal = ({ user, onPostCreated, onClose }) => {
    const [text, setText] = useState('');
    const [images, setImages] = useState([]);
    const [visibility, setVisibility] = useState('public');
    const [loading, setLoading] = useState(false);
    const [previewUrls, setPreviewUrls] = useState([]);

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + images.length > 5) {
            alert("Maximum 5 images allowed");
            return;
        }
        setImages([...images, ...files]);

        // Create preview URLs
        const newPreviews = files.map(file => URL.createObjectURL(file));
        setPreviewUrls([...previewUrls, ...newPreviews]);
    };

    const handleSubmit = async () => {
        if (!text.trim() && images.length === 0) return;

        setLoading(true);
        const formData = new FormData();
        formData.append('text', text);
        formData.append('visibility', visibility);
        images.forEach((img) => formData.append('images', img));

        try {
            const res = await authFetch('/profile-posts/create', {
                method: 'POST',
                body: formData,
            });

            if (res.ok) {
                const newPost = await res.json();
                // Manually populate user info for immediate feed update
                newPost.user = {
                    _id: user._id,
                    username: user.username,
                    nickname: user.nickname,
                    profilePicture: user.profilePicture
                };
                onPostCreated(newPost);
                onClose();
            } else {
                alert("Failed to create post");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Create Post</h3>
                    <button className="close-btn" onClick={onClose}><FaTimes /></button>
                </div>

                <div className="modal-body">
                    <div className="user-preview">
                        <img
                            src={user?.profilePicture || "https://via.placeholder.com/40"}
                            alt=""
                            className="modal-avatar"
                        />
                        <div>
                            <span className="modal-username">{user?.nickname || user?.username}</span>
                            <select
                                className="visibility-select"
                                value={visibility}
                                onChange={(e) => setVisibility(e.target.value)}
                            >
                                <option value="public">🌎 Public</option>
                                <option value="friends-only">👥 Friends</option>
                                <option value="private">🔒 Only Me</option>
                            </select>
                        </div>
                    </div>

                    <textarea
                        placeholder={`What's on your mind, ${user?.nickname || user?.username}?`}
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        autoFocus
                    />

                    {previewUrls.length > 0 && (
                        <div className="image-previews">
                            {previewUrls.map((url, idx) => (
                                <img key={idx} src={url} alt="preview" />
                            ))}
                        </div>
                    )}

                    <div className="modal-actions">
                        <label className="image-upload-btn">
                            <FaImage /> Add Photo
                            <input
                                type="file"
                                multiple
                                accept="image/*"
                                hidden
                                onChange={handleImageChange}
                            />
                        </label>
                        <button
                            className="submit-btn"
                            disabled={loading || (!text && images.length === 0)}
                            onClick={handleSubmit}
                        >
                            {loading ? 'Posting...' : 'Post'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreatePostModal;